import * as jsonpatch from "fast-json-patch";
// import { SetCreateRequest, SetSearchFilter, SetSearchResponse, SessionSet, ProgramSessionSetCreateRequest, ProgramSessionSet, ProgramSessionSetSearchResponse, ProgramSessionSetSearchFilter } from "@api/entities";
import { IWorkoutSessionSetApiClients, WorkoutSessionSetApiClients } from "./workout.session.set.api.client";
import { ProgramSessionSet, ProgramSessionSetCreateRequest, ProgramSessionSetSearchFilter, ProgramSessionSetSearchRequest, ProgramSessionSetSearchResponse, SessionSet, SetSearchFilter, SetSearchResponse } from "src/api/entities";

export interface IWorkoutSessionSetApiService {
    create(workoutID: number, request: ProgramSessionSetCreateRequest): Promise<ProgramSessionSet>;
    getById(id: number): Promise<ProgramSessionSet>;
    searchByExerciseUuid(setSearchRequest: ProgramSessionSetSearchRequest, exerciseUuid: string): Promise<ProgramSessionSet[]>;
    edit(oldWorkoutSet: ProgramSessionSet, updatedWorkoutSet: ProgramSessionSet): Promise<ProgramSessionSet>;
    search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: ProgramSessionSetSearchFilter
    ): Promise<ProgramSessionSetSearchResponse>;
    deleteByUuid(id: string): Promise<{ [key: string]: boolean; }>
}

export class WorkoutSessionSetApiService implements IWorkoutSessionSetApiService {
    private static instance: WorkoutSessionSetApiService;
    private api: IWorkoutSessionSetApiClients;

    private constructor(basePath: string) {
        this.api = WorkoutSessionSetApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (WorkoutSessionSetApiService.instance == null) {
            WorkoutSessionSetApiService.instance = new WorkoutSessionSetApiService(basePath);
        }
        return WorkoutSessionSetApiService.instance;
    }

    async create(workoutID: number, request: ProgramSessionSetCreateRequest): Promise<ProgramSessionSet> {
        return (await this.api.workoutSessionSet.create8(workoutID, request)).data;
    }

    async getById(id: number): Promise<SessionSet> {
        return (await this.api.workoutSessionSet.get7(id)).data;
    }

    async searchByExerciseUuid(setSearchRequest: ProgramSessionSetSearchRequest, exerciseUuid: string): Promise<ProgramSessionSet[]> {
        return (await this.api.workoutSessionSet.searchByExerciseUuid(exerciseUuid, setSearchRequest)).data.data!;
    }

    async deleteByUuid(id: string): Promise<{ [key: string]: boolean; }> {
        const response: { [key: string]: boolean; } = (await this.api.workoutSessionSet.deleteByUuid1(id)).data
        return response
    }

    async edit(oldWorkoutSet: SessionSet, updatedWorkoutSet: SessionSet): Promise<SessionSet> {
        const requestPatch: any = jsonpatch.compare(oldWorkoutSet, updatedWorkoutSet);
        const workout: SessionSet = (
            await this.api.workoutSessionSet.patch4(oldWorkoutSet.id!, requestPatch)
        ).data;
        return workout;
    }

    async search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string },
        filter?: SetSearchFilter
    ): Promise<SetSearchResponse> {
        return (
            await this.api.workoutSessionSet.searchBySets({
                page,
                size,
                query,
                sort,
                filter,
            })
        ).data;
    }
}
